import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import defaultProfileImage from "../assets/profile2.png";
import referralImage from "../assets/Profile/referral_code.png";
import audioIcon from "../assets/Profile/Audio.png";
import videoIcon from "../assets/Profile/Video.png";
import { useNavigate } from "react-router-dom";
import { FormatTime } from "../services/Helper";
import { GetUserByIdApi } from "../services/Api";

const ProfilePage = () => {
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    profilePicture: "",
    audioTalkTime: 0,
    audioTalkHours: 0,
    videoTalkTime: 0,
    videoTalkHours: 0,
  });

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));

  const getUserData = async () => {
    const data = await GetUserByIdApi();
    if (data) {
      setUserDetails({
        name: data.name || "",
        email: data.email || "",
        phoneNumber: data.phoneNumber || "",
        dateOfBirth: data.dateOfBirth || "",
        profilePicture: data.profilePicture || "",
        audioTalkTime: FormatTime(data.audioTalkTime || 0),
        audioTalkHours: FormatTime(data.audioTalkHours || 0),
        videoTalkTime: FormatTime(data.videoTalkTime || 0),
        videoTalkHours: FormatTime(data.videoTalkHours || 0),
      });
    }
  };

  const checkLogin = () => {
    if (userData === null) {
      navigate("/login");
    }
  };

  useEffect(() => {
    checkLogin();
    getUserData();
  }, []);

  return (
    <div className="min-h-screen bg-[#3CC3CD] flex flex-col items-center justify-start">
      <Header />

      {/* Card Container */}
      <div className="mt-10 w-[90%] max-w-md bg-white rounded-3xl shadow-xl p-6 relative overflow-hidden">
        {/* Top Branding */}
        <div className="absolute top-4 left-4 text-[#004d4f] z-10">
          <h1 className="text-xl font-bold leading-tight">good<br />people</h1>
          <p className="text-sm font-light mt-1">Kindred Minds Only</p>
        </div>

        {/* Decorative BG Layer */}
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-[#eafcfd] via-[#d1f4f7] to-[#a7e8ec] opacity-70 z-0" />

        {/* Foreground Content */}
        <div className="relative z-10">
          {/* User Avatar */}
          <div className="flex justify-center mt-20">
            <img
              src={userDetails.profilePicture ? userDetails.profilePicture : defaultProfileImage}
              alt="Profile"
              className="w-24 h-24 rounded-full border-4 border-[#d1f4f7] object-cover"
            />
          </div>

          {/* User Details */}
          <div className="mt-6 text-center">
            <h2 className="text-lg font-semibold text-gray-900">{userDetails.name}</h2>
            <p className="text-sm text-gray-700 mt-1">
              <strong>Email:</strong> {userDetails.email}
            </p>
            <p className="text-sm text-gray-700">
              <strong>Phone:</strong> {userDetails.phoneNumber}
            </p>
            <p className="text-sm text-gray-700">
              <strong>DOB:</strong> {userDetails.dateOfBirth}
            </p>
          </div>

          {/* Info Cards */}
          <div className="mt-6 space-y-4">
            {/* Referral Code Card */}
            <div className="flex items-center bg-[#eafcfd] rounded-xl p-4 shadow-md">
              <div className="bg-[#3CC3CD] p-2 rounded-lg mr-4">
                <img src={referralImage} alt="Referral" className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-800">Referral Code</p>
                <p className="text-xs text-gray-500">Referral Code</p>
              </div>
              <p className="text-sm font-semibold text-gray-700">10 h</p>
            </div>

            {/* Audio Talktime Card */}
            <div className="flex items-center bg-[#eafcfd] rounded-xl p-4 shadow-md">
              <div className="bg-[#3CC3CD] p-2 rounded-lg mr-4">
                <img src={audioIcon} alt="Audio" className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-800">AudioTalkTime:</p>
                <p className="text-xs text-gray-500">{userDetails.audioTalkHours}</p>
              </div>
              <p className="text-sm font-semibold text-gray-700">{userDetails.audioTalkTime}</p>
            </div>

            {/* Video Talktime Card */}
            <div className="flex items-center bg-[#eafcfd] rounded-xl p-4 shadow-md">
              <div className="bg-[#3CC3CD] p-2 rounded-lg mr-4">
                <img src={videoIcon} alt="Video" className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-800">VideoTalkTime:</p>
                <p className="text-xs text-gray-500">{userDetails.videoTalkHours}</p>
              </div>
              <p className="text-sm font-semibold text-gray-700">{userDetails.videoTalkTime}</p>
            </div>
          </div>

          {/* Footer Section */}
          <div className="mt-6 text-center text-xs text-gray-500">
            Referral Code • 8d 18m
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
